export type Application = 1 | 2;    // 1 == OnlineIDE, 2 == SQLIDE

export interface BaseResponse {
    success: boolean;
    message: string;
}

export type UserData = {
    id: number,
    klasse_id: number,
    schule_id: number,
    is_teacher: boolean,
    is_admin: boolean,
    is_schooladmin: boolean,
    locked: boolean,
    username: string,
    familienname: string,
    rufname: string,
    currentWorkspace_id?: number,
    sql_current_workspace_id?: number,

    gui_state?: string, // serialized GuiState
    sql_gui_state?: any,
    settings?: string, // serialized SettingValues 
    sql_settings?: any,

    password?: string,
    is_testuser?: boolean,

    vidis_sub?: string,
    vidis_klasse?: string,
    vidis_akronym?: string,

}

export type GetUserDataRequest = {

}

export type GetUserDataResponse = {
    success: boolean,
    user: UserData,
    classdata: ClassData[], // null if !is_teacher
    schoolName: string,
    vidisSchoolId: string | null,
    schoolSettings: string, // serialized SettingValues
    application: Application
}


export type GetSchoolDataRequest = {
    school_id: number
}

export type GetSchoolDataResponse = {
    success: boolean,
    schoolData?: SchoolData[]
}

export type ClassData = {
    id: number,
    lehrkraft_id: number,
    zweitlehrkraft_id: number,
    schule_id: number,
    name: string,
    aktiv: boolean,
    students: UserData[],
    text?: string
}

export type SchoolData = {
    id: number,
    name: string,
    text?: string, // only form w2ui...
    kuerzel: string,
    classes: ClassData[],
    usersWithoutClass: UserData[],
    userMinutesLastMonth: number,
    userMinutesLastYear: number,
    userMinutesOverall: number
}

export type LogoutRequest = {
    currentWorkspaceId: number
}

export type LogoutResponse = {
    success: boolean
}

export type CRUDResponse = {
    success: boolean,
    message: string,
    id?: number, // in case of create
    error: string
}

export type CRUDUserRequest = {
    type: "create" | "update" | "delete",
    data?: UserData, // for create and update
    ids?: number[], // for delete
}

export type CRUDSchoolRequest = {
    type: "create" | "update" | "delete",
    data?: SchoolData, // for create and update
    id?: number, // for delete
}

export type GetStatisticsRequest = {
    now: boolean
}

export type StatisticData = {
    users: number,
    memory: number,
    time: string,
    requestsPerMinute: number,
    userlist?: string[],
    webSocketSessionCount: number,
    webSocketClientCount: number,
    webSocketRequestPerSecond: number,
    performanceDataList: PerformanceData[]
}

export type PerformanceData = {
    url: string;
    sumTime: number;
    count: number;
}


export type GetStatisticsResponse = {
    success: boolean,
    statisticPeriodSeconds: number,
    data: StatisticData[]
}

export type GetMessagesRequest = {
    type: string;
}

export type Message = {
    text: string,
    type: string,
    done: boolean,
    time: number,
    user_id: number
}

export type GetMessagesResponse = {
    success: boolean;
    messages: Message[];
}

export type ImportSchoolsResponse = {
    success: boolean,
    messageType: string
}

export type KlassData = {
    id: number;
    text: string;
}

export type PruefungState = "preparing" | "running" | "correcting" | "opening";
export var PruefungCaptions: { [index: string]: string } = {
    "preparing": "Vorbereitung",
    "running": "Prüfung läuft",
    "correcting": "Korrektur",
    "opening": "Herausgabe"
}

export type PruefungStudentModeWithId = {
    student_id: number,
    mode: PruefungStudentMode
}

export type PruefungStudentGroupWithId = {
    student_id: number,
    group: string
}

export type Pruefung = {
    id: number,
    name: string,
    datum?: string,
    klasse_id: number,
    template_workspace_a_id: number,
    template_workspace_b_id: number,
    pruefungStudentGroups?: { studentGroups: PruefungStudentGroupWithId[] },
    pruefungStudentModes?: { studentModes: PruefungStudentModeWithId[] },
    state: PruefungState,
    application: Application
}


export type GetPruefungStudentModeRequest = {
    pruefung_id: number
}

export type PruefungStudentMode = "automatic" | "manualOn" | "manualOff";

export type PruefungTableStudentData = {
    id: number,
    name: string,
    username: string,
    grade: string,
    points: string,
    comment: string,
    mode: PruefungStudentMode | { id: PruefungStudentMode, text: string }
    group: string | { id: string, text: string },
}

export type GetPruefungStudentTableDataRequest = {
    pruefung_id: number
}

export type GetPruefungStudentTableDataResponse = {
    success: boolean,
    message: string,
    studentDataList: PruefungTableStudentData[]
}

export type SetPruefungStudentModeRequest = {
    pruefung_id: number,
    student_id: number,
    mode: PruefungStudentMode
}

export type WorkspaceShortData = {
    id: number,
    parent_folder_id?: number,
    sorting_order: number,
    isFolder: boolean,
    name: string,
    text?: string,
    files: string[]
}

export type CRUDPruefungRequest = {
    pruefung?: Pruefung,
    requestType: "create" | "update" | "delete"
}

export type CRUDPruefungResponse = {
    success: boolean,
    newPruefungWithIds?: Pruefung,
    message: string
}



export type StudentPruefungStateInfo = {
    studentId: number,
    timestamp: number,
    state: string,
    running: boolean
}

export type GetPruefungStudentStatesRequest = {
    pruefungId: number
}

export type GetPruefungStudentStatesResponse = {
    success: boolean,
    pruefungState: string,
    pruefungStudentStates: StudentPruefungStateInfo[],
    message: string
}


// data class ReportPruefungStudentStateRequest(var pruefungId: Int, var clientState: String);
// data class ReportPruefungStudentStateResponse(var success: Boolean, var pruefungState: String, var message: String);

export type ReportPruefungStudentStateRequest = {
    pruefungId: number,
    running: Boolean
}

export type ReportPruefungStudentStateResponse = {
    success: boolean,
    pruefungState: string,
    message: string
}

export type GetPruefungenForLehrkraftResponse = {
    success: boolean,
    message: string,
    pruefungen: Pruefung[];
    klassen: KlassData[];
    workspaces: WorkspaceShortData[];
}

export type UpdatePruefungSchuelerDataRequest = {
    schuelerId: number;
    pruefungId: number;
    grade: string;
    points: string;
    mode: PruefungStudentMode;
    group: string;
    attributesToUpdate: string;
}

export type GetGradeRequest = {
    schuelerId: number;
    pruefungId: number;
}

export type GradeData = {
    user_id: number;
    pruefung_id: number;
    grade: string;
    points: string;
    comment: string;
}

export type CreateOrUpdateGradeRequest = {
    schuelerId: number;
    pruefungId: number;
    grade: string;
    points: string;
    comment: string;
}

export type GetGradeResponse = {
    grade: GradeData;
    success: boolean;
    message: string;
}

export type GetTeacherDataRequest = {
    school_id: number
}

export type GetTeacherDataResponse = {
    success: boolean,
    message: string,
    teacherData?: TeacherData[],
    classesWithoutTeacher: ClassData[]
}

export type TeacherData = {
    userData: UserData,
    classes: ClassData[]
}

export type CRUDClassRequest = {
    type: "create" | "update" | "delete",
    data?: ClassData, // for create and update
    ids?: number[], // for delete
}

export type GetClassesDataRequest = {
    wholeSchool: boolean // if true, get all classes of school, else only classes of teacher
}

export type GetClassesDataResponse = {
    success: boolean,
    message: string,
    classDataList: ClassData[]
}


export type ChangeClassOfStudentsRequest = {
    student_ids: number[],
    new_class_id: number
}

export type ChangeClassOfStudentsResponse = {
    success: boolean,
    message: string
}

export type BulkCreateUsersRequest = {
    onlyCheckUsernames: boolean,
    users: UserData[],
    schule_id: number
}

export type BulkCreateUsersResponse = {
    success: boolean,
    namesAlreadyUsed: string[],
    message: string
}

export type LastLoginUserData = {
    id: number,
    username: string,
    familienname: string,
    rufname: string,
    klasse: string,
    vidis_akronym: string,
    vidis_klasse: string,
    yearsSinceLastLogin: number,
    monthsSinceLastLogin: number,
    inactiveSince: string
}

export type GetLastLoginDataRequest = { }
export type GetLastLoginDataResponse = {
    success: boolean,
    message: string,
    userDataList: LastLoginUserData[]
}

export type WorkspaceSettings = {
    language: string,
    libraries?: string[],
    assemblyArchitecture?: string
}

export type GetWorkspacesRequest = {
    ws_userId: number,
    userId: number
}

export type GetWorkspacesResponse = {
    success: boolean,
    message: string,
    workspaces: Workspaces
}

export type Workspaces = {
    workspaces: WorkspaceData[]
}

export type WorkspaceData = {
    name: string,
    isFolder: boolean,
    parent_folder_id: number | null,
    sorting_order: number,
    id: number,
    owner_id: number,
    files: FileData[],
    current_file_id: number,
    settings?: string,       // serialized WorkspaceSettings

    version: number,
    repository_id: number,    // id of repository-workspace
    has_write_permission_to_repository: boolean, // true if owner of this working copy has write permission to repository workspace

    pruefung_id: number,
    readonly: boolean,

    spritesheet_id: number,
    grade?: string,
    points?: string,
    comment?: string

}

export type FileData = {
    name: string,
    id: number,
    text: string,
    text_before_revision: string,
    submitted_date: string,
    student_edited_after_revision: boolean,
    version: number,
    workspace_id: number,
    forceUpdate: boolean,
    is_copy_of_id?: number,
    repository_file_version?: number,
    identical_to_repository_version: boolean,
    isFolder: boolean,
    parent_folder_id: number | null,
    sorting_order: number
}
